var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSearchBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.5C5 7.467 7.467 5 10.5 5c3.032 0 5.5 2.467 5.5 5.5S13.532 16 10.5 16A5.506 5.506 0 015 10.5zm16 8.924l-4.378-4.378a7.515 7.515 0 001.485-4.493C18.107 6.388 14.718 3 10.553 3 6.388 3 3 6.388 3 10.553s3.388 7.554 7.553 7.554a7.514 7.514 0 004.492-1.485L19.424 21 21 19.424z",
    fill: "#252525",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchBlack);
export default __webpack_public_path__ + "static/media/ic_search_black.0c61a304f4abe7fc2a6a3e6b45983f52.svg";
export { ForwardRef as ReactComponent };